import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './saveTripSearch.actions.js';
import getters from './saveTripSearch.getters.js';
import mutations from './saveTripSearch.mutations.js';
import state from './saveTripSearch.state.js';

BaseStore.registerModule('saveTripSearch', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('saveTripSearch');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
